<template>
  <div class="modal-bottom">
    <h6 class="qty-title">{{ _T('quantity') }}</h6>
    <QtyBox :qty="item.quantity || 1" :index="item.index"></QtyBox>
    <a
      v-if="addToCartAction"
      href="javascript:void(0)"
      data-dismiss="modal"
      @click="addToItem"
      class="btn btn-solid d-none d-lg-block"
    >
      <svg fill="none" width="14" height="12">
        <use xlink:href="#cartW" />
      </svg>
      {{ _T(addToCartAction) }}
    </a>
    <a
      v-else
      data-dismiss="modal"
      href="javascript:void(0)"
      @click="addToCart"
      class="btn btn-solid"
    >
      <svg fill="none" width="14" height="12">
        <use xlink:href="#cartW" />
      </svg>
      {{ _T('Add to cart') }}
    </a>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapState } from 'vuex'
import QtyBox from '../QtyBox'
export default {
  computed: {
    ...mapState({
      item: state => state.cart_store.selectedItem,
    }),
    ...mapGetters(['_T_DB', '_T', 'selected_modifiers']),
  },
  props: ['addToCartAction'],
  components: {
    QtyBox,
  },
  methods: {
    ...mapActions(['addItemToCart']),
    addToCart () {
      let item = { ...this.$store.state.cart_store.selectedItem }
      //attach modifiers here
      item.modifiers = this.selected_modifiers
      this.addItemToCart(item)
      this.$bvModal.hide('MobileCart')
      // this.$store.commit('SET_ITEM_DETAIL_POPUP', false)
    },
    addToItem () {
      let item = { ...this.$store.state.cart_store.selectedItem }
      //attach modifiers here
      item.modifiers = this.selected_modifiers
      // this.$store.commit('SET_ITEM_DETAIL_POPUP', false)
      this.$bvModal.hide('combo-modifiers')
      this.$store.commit('combo_items_store/SET_MODIFIERS', item, {
        root: true,
      })
      this.$store.commit('SELECT_MODIFIERS', {})
    },
  },
}
</script>

<style lang="scss" scoped>
.modifier-side-popup {
  &.open-popup {
    .modal-bottom {
      right: 0px !important;
    }
  }
}
.modal-bottom {
  background: $white;
  box-shadow: 0px -$px4 $px34 rgba($black, 0.07);
  padding: $px12 $px30;
  position: fixed;
  bottom: 0;
  max-width: $px600;
  width: 100%;
  right: -$px600 !important;
  transition: opacity 0.3s linear, right 0.3s ease-out !important;
  display: flex;
  align-items: center;
  .qty-title {
    font-weight: normal;
    font-size: $px14;
    line-height: $px22;
    letter-spacing: 0.5px;
    color: $font-color;
    margin-bottom: 0;
    text-transform: capitalize;
  }
  .btn-solid {
    margin-left: 10px;
    text-transform: capitalize;
    svg,
    img {
      margin-right: $px12;
    }
    &:hover,
    &:focus {
      .content {
        border-color: $color-primary;
        .name,
        .price {
          color: $color-primary;
        }
      }
    }
    &:hover {
      svg {
        path {
          fill: $color-primary !important;
        }
      }
    }
  }
}
</style>
